var map = {
	"./hht1_ep8_minisitcom_01.png": 381,
	"./hht1_ep8_minisitcom_02.png": 382,
	"./hht1_ep8_minisitcom_03.png": 383,
	"./hht1_ep8_minisitcom_04.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;